import Application from "../../Application";
import { INotificationService } from "../../service/notification/NotificationService";
import ReportingPeriodApplicantDocumentsPresenter, {
  IReportingPeriodApplicantDocumentsPresenter
} from "../../presenter/reporting/ReportingPeriodApplicantDocumentsPresenter";
import { IReportingPeriodApplicantDocumentService } from "../../service/document/ReportingPeriodApplicantDocumentService";

export default class ShowReportingPeriodApplicantDocumentsInteractor {
  private application: Application;
  private output?: IReportingPeriodApplicantDocumentsPresenter;
  private notificationService: INotificationService;
  private reportingPeriodApplicantDocumentService: IReportingPeriodApplicantDocumentService;

  constructor(
    application,
    notificationService,
    reportingPeriodApplicantDocumentService
  ) {
    this.application = application;
    this.notificationService = notificationService;
    this.reportingPeriodApplicantDocumentService =
      reportingPeriodApplicantDocumentService;
  }

  async getInitialData(reportingPeriodApplicantId: number) {
    try {
      const [documents, allowedFileTypes] = await Promise.all([
        this.reportingPeriodApplicantDocumentService.getReportingPeriodApplicantDocuments(
          reportingPeriodApplicantId
        ),
        this.reportingPeriodApplicantDocumentService.getAllowedFileTypes()
      ]);

      return { documents, allowedFileTypes };
    } catch (error) {
      this.notificationService.showError((error as any).message);
    }
  }

  execute(reportingPeriodApplicantId: number) {
    this.output = ReportingPeriodApplicantDocumentsPresenter({
      application: this.application,
      initialState: { documents: [], reportingPeriodApplicantId }
    });

    this.getInitialData(reportingPeriodApplicantId).then((initilData) =>
      this.output?.setInitialData(initilData ?? {})
    );

    return this.output;
  }
}
